import React from 'react';

interface MeasurementIconProps {
    fill?: string;
}

export const OpeningIcon = ({ fill = 'black' }: MeasurementIconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clipPath="url(#clip0_6001_51742)">
                <path
                    d="M13.3333 14.6665V3.33321C13.3333 2.23054 12.436 1.33321 11.3333 1.33321H10.5527C10.3925 0.879299 10.0739 0.498464 9.65536 0.260726C9.23683 0.0229871 8.74656 -0.055674 8.27467 0.0392057L4.274 0.839206C3.82136 0.931118 3.41429 1.17636 3.12147 1.53355C2.82865 1.89074 2.66802 2.338 2.66667 2.79987V14.6665H0V15.9999H16V14.6665H13.3333ZM12 3.33321V14.6665H10.6667V2.66654H11.3333C11.7007 2.66654 12 2.96521 12 3.33321ZM4 2.79987C4 2.48321 4.22533 2.20854 4.536 2.14654L8.536 1.34654C8.73133 1.30854 8.93467 1.35854 9.08933 1.48521C9.24467 1.61187 9.33333 1.80054 9.33333 2.00054V14.6665H4V2.79987ZM8 7.99987C7.99996 8.13124 7.97404 8.26131 7.92373 8.38266C7.87341 8.50401 7.79969 8.61426 7.70677 8.70712C7.61385 8.79998 7.50355 8.87362 7.38217 8.92385C7.26079 8.97409 7.1307 8.99992 6.99933 8.99987C6.86797 8.99983 6.7379 8.97391 6.61655 8.9236C6.4952 8.87329 6.38495 8.79957 6.29209 8.70665C6.19923 8.61373 6.12558 8.50343 6.07535 8.38204C6.02512 8.26066 5.99929 8.13057 5.99933 7.99921C5.99942 7.7339 6.1049 7.4795 6.29256 7.29196C6.48022 7.10442 6.7347 6.99912 7 6.99921C7.26531 6.99929 7.51971 7.10477 7.70724 7.29243C7.89478 7.48009 8.00009 7.73457 8 7.99987Z"
                    fill={fill}
                />
            </g>
            <defs>
                <clipPath id="clip0_6001_51742">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
